// Guide sheet: how the game works, strategy tips and a card for every troop (portrait, role, stats).
import { t } from './i18n.js';
import { TR, TORD, HEROES, DMGM, troopMaxLvl } from './data.js';
import { $ } from './dom.js';
import { tLvl } from './economy.js';
import { esc, fmt, troopDot } from './ui.js';

let guideTab = 'video';
const BASICS = ['res', 'hall', 'build', 'gems', 'spells', 'trophy', 'clan'];
const STRATEGY = ['scout', 'tanks', 'walls', 'air', 'stars', 'layout', 'spend'];

function unlockHall(k) { for (let c = 1; c <= 17; c++) if (troopMaxLvl(k, c) > 0) return c; return 17; }
const roleOf = d => d.heal ? 'roleHeal' : d.air ? 'roleAir' : d.ranged ? 'roleRanged' : 'roleMelee';
const prefOf = d => ({ def: 'prefDef', res: 'prefRes', wall: 'prefWall', heal: 'prefHeal', air: 'prefAirDef' })[d.pref] || 'prefAny';

function troopCard(k) {
  const d = TR[k], L = tLvl(k), m = DMGM(L), hp = Math.round(d.hp * m), dps = d.heal ? 0 : Math.round(d.dmg * m / d.cd);
  const tags = [t(roleOf(d)), t(prefOf(d))]; if (d.splash) tags.push(t('tagSplash')); if (d.jump) tags.push(t('tagJump')); if (d.burrow) tags.push(t('tagBurrow')); if (d.suicide) tags.push(t('tagOnce'));
  return `<div class="gcard"><div class="gport">${troopDot(k, 34)}</div><div class="gtx">
    <div class="gname">${esc(t('t_' + k))} <span class="mt">· ${esc(t('b_core'))} ${unlockHall(k)} · ${d.res === 'v' ? 'ETH' : 'SOL'}</span></div>
    <div class="gtags">${tags.map(x => `<span>${esc(x)}</span>`).join('')}</div>
    <div class="d">${esc(t('dt_' + k))} ${esc(t('gt_' + k))}</div>
    <div class="gstats"><span>❤ ${fmt(hp)}</span>${d.heal ? `<span>✚ ${fmt(d.heal * m)}/s</span>` : `<span>⚔ ${fmt(dps)}/s</span>`}<span>⬚ ${d.sp}</span><span>➶ ${d.range}</span><span>${esc(t('level'))} ${L}/${d.lmax}</span></div>
  </div></div>`;
}

function renderGuide() {
  const tabs = $('guideTabs'); tabs.innerHTML = '';
  for (const id of ['video', 'basics', 'strategy', 'troops', 'heroes']) { const b = document.createElement('button'); b.textContent = t('gtab_' + id); if (id === guideTab) b.className = 'on'; b.onclick = () => { guideTab = id; renderGuide(); }; tabs.appendChild(b); }
  const el = $('guideBody'); let h = '';
  if (guideTab === 'video') {
    // beginner's walkthrough (public/guide/): loads only when played
    h = `<p class="sub">${esc(t('gVideoIntro'))}</p><video class="gvid" src="/guide/beginners-guide.mp4" poster="/guide/beginners-guide.jpg" controls playsinline preload="none"></video>`;
  } else if (guideTab === 'basics' || guideTab === 'strategy') {
    const list = guideTab === 'basics' ? BASICS : STRATEGY, pre = guideTab === 'basics' ? 'gb_' : 'gs_';
    h = `<div class="glist">${list.map(k => `<div class="gtip"><b>${esc(t(pre + k))}</b><p>${esc(t(pre + k + '_d'))}</p></div>`).join('')}</div>`;
  } else if (guideTab === 'troops') {
    h = `<p class="sub">${esc(t('gTroopsIntro'))}</p><h4 class="shoph">${esc(t('energyTroops'))}</h4>${TORD.e.map(troopCard).join('')}<h4 class="shoph">${esc(t('voidTroops'))}</h4>${TORD.v.map(troopCard).join('')}`;
  } else {
    h = `<p class="sub">${esc(t('gHeroesIntro'))}</p>` + Object.keys(HEROES).map(k => { const H = HEROES[k];
      return `<div class="gcard"><div class="gport">${troopDot('h_' + k, 34)}</div><div class="gtx"><div class="gname">👑 ${esc(t('hero_' + k))} <span class="mt">· ${esc(t('b_herohall'))} ${H.hh}</span></div>
        <div class="gtags"><span>${esc(H.air ? t('roleAir') : H.range > 2 ? t('roleRanged') : t('roleMelee'))}</span><span>⚡ ${esc(H.ab)}</span></div><div class="d">${esc(t('ab_' + k))}</div>
        <div class="gstats"><span>❤ ${fmt(H.hp)}</span><span>⚔ ${fmt(H.dmg / H.cd)}/s</span><span>${esc(t('maxLvl'))} ${H.caps[H.caps.length - 1]}</span></div></div></div>`; }).join('');
  }
  el.innerHTML = h;
}

export { renderGuide };
